import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 54px 28px;
        gap: 36px;
    `,

    "Content": styled.div`
        display: flex;
        flex-direction: column;
        gap: 24px;

        & > p {
            ${({ theme }) => theme.font["medium-regular"]};
        }
    `,
    "TitleDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;

        & > h2 {
            ${({ theme }) => theme.font["large-medium"]};
            
        }

        & > p {
            ${({ theme }) => theme.font["medium-regular"]};
            color: ${({ theme }) => theme.color["grey3"]};
        }
    `,

    "ImgList": styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,

}